export const REQUESTING = {
	FETCHING : 'REQUESTING_FETCHING',
	LOADED : 'REQUESTING_LOADED',
	LISTENING : 'REQUESTING_LISTENING',
	NONE : 'REQUESTING_NONE',
	FAIL : 'REQUESTING_FAIL',
};

export const ROUTES = {
	SEARCH_QUIZ_SELECTED: 'ROUTES_SEARCH_QUIZ_SELECTED',
	SEARCH_QUIZ_QUERIED : 'ROUTES_SEARCH_QUIZ_QUERIED',
	CREATE_QUIZ_SELECTED: 'ROUTES_CREATE_QUIZ_SELECTED',
	SHOW_RECIPE: 'ROUTES_SHOW_RECIPE',
	REQUEST_QUIZ_EDITOR: 'ROUTES_REQUEST_QUIZ_EDITOR',
	REQUEST_PLAY_QUIZ: 'ROUTES_REQUEST_PLAY_QUIZ',
	RECIPE_DETAIL: 'ROUTES_RECIPE_DETAIL',
	PROFILE: 'ROUTES_PROFILE',
	USER: 'ROUTES_USER',
	LANDING_PAGE : 'ROUTES_LANDING_PAGE',
	HOME_PAGE : 'ROUTES_HOME_PAGE',
	TERMS_PAGE : 'ROUTES_TERMS_PAGE',
	PRIVACY_POLICY_PAGE : 'ROUTES_PRIVACY_POLICY_PAGE',
};

export const AUTH = {
	LOGIN_REQUEST : 'AUTH_LOGIN_REQUEST',
	LOGGED_IN : 'AUTH_LOGGED_IN',
	LOGGED_OUT : 'AUTH_LOGGED_OUT',
	NONE : 'AUTH_NONE',
	SET_AUTH_OBSERVER : 'SET_AUTH_OBSERVER'
};

export const PROF = {
	PREFIX : 'PROF_',
	NONE : 'PROF_NONE',
	UPLOAD_IMAGE : 'PROF_UPLOAD_IMAGE',
	READ_PROFILE : 'PROF_READ_PROFILE',
	ADD_PROFILE : 'PROF_ADD_PROFILE',
	UPDATE_PROFILE :'PROF_UPDATE_PROFILE',
	DOWNLOAD_IMAGE : 'PROF_DOWNLOAD_IMAGE',
	INIT_PROFILE : 'PROF_INIT_PROFILE'
};

export const USER = {
	FETCHING : 'USER_FETCHING',
	PROF_LOADED : 'USER_PROF_LOADED',
	RECIPE_LOADED : 'USER_RECIPE_LOADED',
	PROF_FAILED_LOADING : 'USER_PROF_FAILED_LOADING',
	RECIPE_FAILED_LOADING : 'USER_RECIPE_FAILED_LOADING',
	NONE : 'USER_NONE',
};

export const SCORE = {
	FETCHING : 'SCORE_FETCHING',
	LOADED : 'SCORE_LOADED',
	NONE : 'NONE',
};

export const DETAILED_RECIPE = {
	PREFIX : 'DETAILED_RECIPE_',
	READ_SCORE : 'DETAILED_RECIPE_SCORE_LOADED',
	CREATE_SCORE : 'DETAILED_RECIPE_CREATE_SCORE',
	READ_RECIPE : 'DETAILED_RECIPE_READ_RECIPE',
};


export const CREATE_QUIZ = {
	PREFIX : 'CREATE_QUIZ_',
	READ_RECIPES : 'CREATE_QUIZ_READ_RECIPES',
	INIT_RECIPES : 'CREATE_QUIZ_INIT_RECIPES',
};

export const PLAY_QUIZ = {
	PREFIX : 'PLAY_QUIZ_',
	READ_RECIPE : 'PLAY_QUIZ_READ_RECIPE',

};

export const SEARCH_QUIZ = {
	PREFIX : 'SEARCH_QUIZ_',
	READ_RECIPE : 'SEARCH_QUIZ_READ_RECIPE',
	REFRESH : 'SEARCH_QUIZ_REFRESH'
};

export const RECIPE = {
	PREFIX : 'RECIPE_',
	CREATE_QUIZ : 'RECIPE_CREATE_QUIZ',
	UPDATE_QUIZ : 'RECIPE_UPDATE_QUIZ',
	UPDATE_RECIPE : 'RECIPE_UPDATE_RECIPE',
	DELETE_QUIZ : 'RECIPE_DELETE_QUIZ',
	DELETE_RECIPE : 'RECIPE_QUIZ_DELETE_RECIPE',
	READ_QUIZ : 'RECIPE_QUIZ_READ_QUIZ',
	CLOSE_QUIZ : 'RECIPE_QUIZ_CLOSE_QUIZ_EDITOR',
};